import request from '@/utils/axios'

export function visit (params) {
  return request({
    url: '/api/visits',
    methods: 'get',
    params: params
  })
}
